import { resource, RequestConfig } from '../helper/resource';

/**
 * 基金开户流程：isHKFund
 */
export function HKFundUsingPOST(req: Production | void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.post('/fundAccount/HKFund', req, config);
}

/**
 * 基金开户流程：无感开通TA账户
 */
export function openTAUsingPOST(req: Production | void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.post('/fundAccount/openTA', req, config);
}

/**
 * 基金详情页:买入/定投资格判断
 */
export function prejudgmentUsingPOST(req: Production | void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.post('/fundAccount/prejudgment', req, config);
}

/**
 * 基金开户流程：无感开通TA账户
 */
export function testUsingPOST(req: Production | void, config?: RequestConfig): Promise<void> {
  return resource.post('/fundAccount/test', req, config);
}
